<template>
  <div class="indexAdvertisingList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="classify">
            <el-option key label="全部分类" value="" ></el-option>
            <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="adName" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>

      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jumpToAdd">添加</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"  :height="tableData.length > 0 ? require('@/config/enum').tableheight530 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.acheckbox"></el-table-column>
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column prop="id" :label="$t('lang.lab_AdverId')" width="150">
        </el-table-column>
        <el-table-column prop="adName" label="名称">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.adName&&scope.row.adName.length>20"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.adName }}
                </span>
              </div>
              <div>
                {{ scope.row.adName.substring(0, 20) | valueIsNull }}
                <span v-if="scope.row.adName.length>20">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.adName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="classify" label="分类">
          <template slot-scope="scope">
            <span v-if="scope.row.classify === 1">{{classifyList[0].label}}</span>
            <span v-if="scope.row.classify === 2">{{classifyList[1].label}}</span>
            <span v-if="scope.row.classify === 3">{{classifyList[2].label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sortId" label="排序">
        </el-table-column>
        <el-table-column sortable prop="startTime" label="开始时间" width="230">
          <template slot-scope="scope">
            {{ scope.row.startTime | time }}
          </template>
        </el-table-column>
        <el-table-column sortable prop="endTime" label="结束时间" width="230">
          <template slot-scope="scope">
            {{ scope.row.endTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="150">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteItem(scope.row)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'yhAdvertisingManageList',
    data() {
      return {
        pageCount: 0, // 总数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        adName: '', // 保存输入的查询词
        classify: '', // 分类
        tableData: [], // 首页广告管理列表数据
        acheckbox: require('@/config/enum').acheckbox, // 是否隐藏复选框
        deletename: require('@/config/enum').deletename,
        classifyList: [{
            value: 1,
            label: '首页轮播图'
          },
          {
            value: 2,
            label: '精彩活动'
          },
          {
            value: 3,
            label: '精彩推荐'
          }
        ], // 分类, // 广告类型下拉列表
      }
    },
    created() {
       setTimeout(() => {
         window.localStorage.setItem('yhAdvertisingForm', '')
         window.localStorage.setItem('yhAdvertisingData', '')
      }, 200)
      this.getList()
    },
    activated() {
      this.getList()
    },
    computed: {
      ...mapGetters({ gardenId: 'gardenId' })
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.commit()
      }
    },
    methods: {
      // 删除方法
      deleteItem(row) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            this.$delete(`/gardenShopAd/${row.id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 编辑方法
      edit(id) {
        window.localStorage.setItem('yhAdvertisingForm', '')
        window.localStorage.setItem('yhAdvertisingData', '')
        this.$router.push({
          name: 'yhAdvertisingManageAdd',
          query: { id: id }
        })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getList()
      },
      // 添加方法
      jumpToAdd() {
        window.localStorage.setItem('yhAdvertisingForm', '')
        window.localStorage.setItem('yhAdvertisingData', '')
        this.$router.push({
          name: 'yhAdvertisingManageAdd'
        })
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 页面列表展示方法
      getList() {
        let loading = this.$loading()
        this.$get(`/gardenShopAd?adName=${this.adName}&classify=${this.classify}&pageNo=1&pageSize=10&gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询按钮
      commit() {
        this.pageNo = 1
        this.getList()
      },
    }
  }
</script>

<style lang="scss">
</style>